import * as qs from "qs";
export const paramsSerializer = function (params) {
    return qs.stringify(params, { arrayFormat: "brackets", encode: true, encodeValuesOnly: true });
};
